import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import JobState, {IJob, JobList, JobTypeList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<JobState> = {
  [mutationType.GET_LISTS](
    state: JobState,
    data: JobList,
  ): void {
    state.list = data
  },
  [mutationType.GET_BY_ID](
    state: JobState,
    data: IJob,
  ): void {
    state.byId = data
  },
  [mutationType.CREATE](
    state: JobState,
    data: object,
  ): void {
    state.create = data
  },
  [mutationType.UPDATE](
    state: JobState,
    data: object,
  ): void {
    state.update = data
  },
  [mutationType.DELETE](
    state: JobState,
    data: object,
  ): void {
    state.delete = data
  },
  [mutationType.JOB_TYPE](
    state: JobState,
    data: JobTypeList,
  ): void {
    state.jobType = data
  },
}

export default mutations
